import type { Messages } from './en';

const ar: Partial<Messages> = {
  'lang.label': 'اللغة',
  'nav.tracker': 'متابعة الطلب',
  'nav.robux': 'طلب روبوكس',
  'common.loading': 'جاري تحميل طلبك…',
  'common.order': 'الطلب #{id}',
  'common.submit': 'إرسال',

  'landing.title': 'تابع طلبك',
  'landing.sub': 'اكتب رقم طلبك لمتابعة حالة التسليم لحظة بلحظة',
  'landing.header': 'رقم طلبك',
  'landing.label': 'رقم الطلب',
  'landing.placeholder': 'اكتب رقم طلبك',
  'landing.btn': 'تابع الطلب',

  'terms.title': 'قبل ما تكمل',
  'terms.intro': 'من فضلك اقرأ النقاط التالية ووافق عليها عشان تكمل طلبك.',
  'terms.p1': '<b>أنت المسؤول عن بيانات الحساب اللي هتدخلها.</b> بمجرد دخول الحساب في نظامنا بيتم النقل تلقائياً، فتأكد إنه الحساب الصحيح — مش هنقدر نحوّل الكوينز لحساب تاني بعد كده.',
  'terms.p2': '<b>العملية كلها تلقائية.</b> سرعتها أو بطؤها مش قابلة للتعديل أو التحكم — نظامنا متزامن مع نظام EA Detection، فالعملية بتكمل طالما النظام شايفها آمنة وبتقف لو مش آمنة.',
  'terms.p3': '<b>إحنا مش بنغطي ضريبة EA ({pct}%).</b> أنت طلبت {gross}K كوينز، فهيوصلك <b>{net}K كوينز</b> صافي.',
  'terms.p4': '<b>لو فيه أي مشكلة في النقل، كلّم الموظف المتابع معاك الأول.</b> متفتحش ديسبيوت على طول — ده مش بيسرّع الموضوع، ده بيصعّبه أكتر.',
  'terms.agree': 'قرأت كل النقاط السابقة وأوافق عليها',
  'terms.accept': 'أوافق — كمّل',
  'terms.decline': 'لا أوافق',
  'terms.declinedTitle': 'مفيش مشكلة',
  'terms.declinedBody': 'مفيش مشكلة — لسه مفيش أي حاجة بدأت على حسابك. لو في نقطة مش واضحة اسأل الموظف المتابع معاك. تقدر ترجع للصفحة دي وتكمّل في أي وقت تكون جاهز فيه.',
  'terms.back': 'رجوع',

  'tax.hero': 'اشتريت {gross}K · هيوصل ناديك {net}K',
  'tax.noteTitle': 'EA بتاخد {pct}% من كل عملية بيع كوينز',
  'tax.noteBody': 'أنت اشتريت <b>{gross}K كوينز</b>. ضريبة EA ({pct}%) مش بنغطيها، فهيوصل ناديك <b>{net}K كوينز</b> — وده المبلغ اللي طلبك بيغطيه.',
  'tax.finished': 'وصل ناديك <b>{net}K كوينز</b> (اشتريت {gross}K ناقص ضريبة EA {pct}%).',

  'hero.loading': 'جاري التحميل…',
  'hero.notFound': 'الطلب غير موجود',
  'hero.unknown': 'غير معروف',
  'hero.cancelled': 'الطلب ملغي',
  'hero.awaiting': 'في انتظار بياناتك',
  'hero.delivered': 'تم التسليم بنجاح!',
  'hero.dailyLimit': 'تم الوصول للحد اليومي',
  'hero.no2fa': 'فعّل التحقق عند الدخول',
  'hero.newBA': 'مطلوب كود احتياطي جديد',
  'hero.wrongPass': 'بيانات الدخول غير صحيحة',
  'hero.processing': 'جاري المعالجة',
  'hero.paused': 'الطلب متوقف مؤقتاً',
  'hero.delivering': 'جاري تسليم الكوينز',
  'badge.cancelled': 'ملغي',
  'badge.action': 'مطلوب إجراء منك',
  'badge.complete': 'مكتمل',
  'badge.autoResume': 'يكمل تلقائياً بكرة',
  'badge.support': 'تواصل مع الدعم',
  'badge.retry': 'إعادة محاولة تلقائية',
  'badge.progress': 'جاري التنفيذ',
  'hero.pct': 'تم تسليم {pct}% · {delivered}K من {ordered}K كوينز',
  'hero.refresh': 'تحديث',

  'msg.notFound': 'الطلب غير موجود',
  'msg.netRetry': 'خطأ في الشبكة — جاري إعادة المحاولة…',
  'msg.submitFail': 'فشل الإرسال. حاول مرة أخرى.',
  'msg.net': 'خطأ في الشبكة. حاول مرة أخرى.',
  'msg.resumed': 'تم استئناف الطلب! جاري تحديث الحالة…',
  'msg.waitLogout': 'انتظر لحظة بعد تسجيل الخروج ثم حاول مرة أخرى.',
  'msg.cantResumeWhy': 'مش ممكن الاستئناف دلوقتي — {reason}. هيكمل تلقائياً.',
  'msg.cantResume': 'مش ممكن الاستئناف دلوقتي — طلبك هيكمل تلقائياً. حاول بعد شوية.',
  'msg.resumeFail': 'فشل الاستئناف. تواصل مع الدعم.',
  'msg.retrying': 'جاري إعادة المحاولة! تحديث الحالة…',
  'msg.retryFail': 'فشلت إعادة المحاولة — حاول بعد شوية.',
  'msg.cancelledTitle': 'تم إلغاء هذا الطلب.',
  'msg.cancelledBody': 'تواصل مع الموظف اللي جهّز طلبك لو شايف إن ده حصل بالغلط.',

  'pending.banner': 'طلبك لـ <b>{amount}K كوينز</b> على <b>{platform}</b> جاهز. أدخل بيانات حساب EA بالأسفل لبدء التسليم. بياناتك بتتبعت بشكل آمن ومش بتتخزن.',
  'pending.header': 'بيانات حساب EA الخاص بك',
  'pending.logout': '<b>قبل الإرسال:</b> سجّل خروج من تطبيق EA وFUT Web App والتطبيق المرافق على كل الأجهزة.',
  'pending.email': 'إيميل حساب EA',
  'pending.emailPh': 'your@email.com',
  'pending.password': 'كلمة سر حساب EA',
  'pending.passwordPh': 'كلمة سر EA',
  'pending.ba1': 'الكود الاحتياطي #1',
  'pending.ba1Hint': '— من إعدادات أمان EA',
  'pending.ba1Ph': 'مثال: 12345678',
  'pending.ba2': 'الكود الاحتياطي #2',
  'pending.ba3': 'الكود الاحتياطي #3',
  'pending.optional': '— اختياري',
  'pending.hideExtra': '− إخفاء الأكواد الإضافية',
  'pending.showExtra': '+ أضف أكواد احتياطية أكتر (مُستحسن)',
  'pending.start': 'ابدأ التسليم',
  'pending.starting': 'جاري بدء التسليم…',
  'pending.locked': 'من فضلك اقرأ الشروط ووافق عليها للمتابعة.',
  'pending.reopenTerms': 'راجع الشروط مرة أخرى',

  'active.delivered': 'تم تسليم الكوينز! ⚽',
  'active.thanks': 'شكراً لاختيارك 911GamingStore. استمتع!',
  'active.stayOut': '<b>ابقَ مسجّل خروج</b> من تطبيق EA وFUT Web App والتطبيق المرافق على كل الأجهزة طول ما الطلب شغال.',
  'active.meta': ' · حوالي 10 دقايق لكل 100K · الحد اليومي: 1–3 مليون كوينز (يكمل تلقائياً اليوم التالي)',
  'active.dailyHeader': 'تم الوصول لحد النقل اليومي',
  'active.dailyBody': 'تم الوصول لحد النقل اليومي. ده إجراء حماية عادي — طلبك هيكمل تلقائياً بكرة. مش مطلوب منك أي حاجة. تقدر تدخل وتلعب عادي وحتى تصرف الكوينز لو عايز — الطلب هيكمل تلقائياً بعد حوالي 30 ساعة. تقدر تعرف الوقت المتبقي بالزر بالأسفل. شكراً لصبرك 👍',
  'active.retryBtn': 'صلّحت المشكلة — أعد المحاولة',
  'active.retrying': 'جاري إعادة المحاولة…',
  'metric.ordered': 'المطلوب',
  'metric.willReceive': 'هيوصلك',
  'metric.delivered': 'تم تسليمه',
  'metric.remaining': 'المتبقي',
  'progress.title': 'تقدم التسليم',
  'progress.starting': 'جاري البدء…',
  'progress.inProgress': 'جاري التنفيذ',
  'progress.complete': 'مكتمل',

  'ba.titleNo2fa': 'فعّل التحقق عند الدخول وأدخل كود احتياطي',
  'ba.titleNew': 'مطلوب كود احتياطي جديد',
  'ba.descNo2fa': 'حساب EA بتاعك مفيهوش تحقق عند الدخول. فعّله الأول، بعدين ولّد أكواد احتياطية وأدخل واحد بالأسفل:',
  'ba.descNew': 'الكود الاحتياطي غلط أو منتهي. اتبع الخطوات التالية ثم أدخل كود جديد بالأسفل:',
  'ba.no2faSteps': 'اذهب إلى <b>account.ea.com</b> ← الأمان ← التحقق عند الدخول\nفعّل التحقق — اختر تطبيق المصادقة أو الإيميل\nبعد التفعيل اذهب إلى <b>الأكواد الاحتياطية</b> وولّد مجموعة جديدة\nانسخ واحد من الأكواد الجديدة وأدخله بالأسفل',
  'ba.newSteps': 'اذهب إلى <b>account.ea.com</b> ← الأمان ← التحقق عند الدخول ← الأكواد الاحتياطية\nولّد مجموعة جديدة من الأكواد الاحتياطية\nانسخ واحد من الأكواد الجديدة وأدخله بالأسفل',
  'ba.placeholder': 'كود احتياطي جديد',
  'ba.ok': 'تم تحديث الكود الاحتياطي! جاري إعادة تشغيل الطلب…',
  'ba.fail': 'فشل. راجع الكود أو تواصل مع الدعم.',
  'cred.title': 'حدّث بيانات الدخول',
  'cred.desc': 'يبدو إن الإيميل أو كلمة السر اتغيرت. راجع وحدّث بياناتك بالأسفل:',
  'cred.steps': 'اذهب إلى <b>account.ea.com</b> وتأكد إن الإيميل وكلمة السر صح\nلو غيّرت كلمة السر مؤخراً أدخل الجديدة بالأسفل\nتأكد إنك مسجّل خروج من كل تطبيقات EA قبل الإرسال',
  'cred.emailPh': 'إيميل حساب EA (لو اتغير)',
  'cred.passPh': 'كلمة سر حساب EA الجديدة',
  'cred.ok': 'تم تحديث البيانات! جاري إعادة تشغيل الطلب…',
  'cred.fail': 'فشل التحديث. تواصل مع الدعم.',
  'resume.title': 'الطلب متوقف — استأنفه لما تكون جاهز',
  'resume.desc': 'طلبك متوقف. تأكد إنك مسجّل خروج من كل تطبيقات EA ثم اضغط استئناف.',
  'resume.btn': 'استئناف الطلب',
  'resume.busy': 'جاري الاستئناف…',
  'cool.title': 'تحقق من الوقت المتبقي',
  'cool.btn': 'تحقق من الانتظار',
  'cool.busy': 'جاري التحقق…',
  'cool.desc': 'اعرف المدة المتبقية لحد ما يتجدد حد النقل اليومي ويكمل طلبك تلقائياً.',
  'cool.ready': 'تم تجديد الحد! طلبك هيكمل خلال لحظات.',
  'cool.hm': 'متبقي حوالي {h} ساعة و{m} دقيقة',
  'cool.min': 'متبقي حوالي {m} دقيقة',
  'shot.before': 'إثبات الحساب (قبل)',
  'shot.latest': 'آخر إثبات للنقل',
  'shot.none': 'غير متاح بعد',
  'row.status': 'الحالة',
  'row.accountCheck': 'فحص الحساب',
  'row.economy': 'حالة الاقتصاد',
  'row.balance': 'رصيد الحساب',
  'row.created': 'تاريخ إنشاء الطلب',
  'row.coins': '{n} كوينز',


  // ── Shop with us (replaces the old promo) + footer ─────────
  'shop.eyebrow': 'مش بس كوينز FC',
  'shop.title': 'كل اللي بتلعبه. في متجر واحد.',
  'shop.lede': 'شحن ألعاب وبطاقات هدايا ومفاتيح ألعاب بأسعار واضحة ومنخفضة — تسليم تلقائي 24/7.',
  'shop.from': 'من {price}',
  'shop.floor': 'الأسعار تبدأ من {price}',
  'shop.browse': 'تصفح كل المنتجات',
  'shop.cta': 'تسوّق من 911 Gaming Store',
  'shop.pay': 'ادفع بـ',
  'shop.f1t': 'أسعار منخفضة وواضحة',
  'shop.f1d': 'بتشوف السعر كامل قبل ما تدفع — من غير مفاجآت.',
  'shop.f2t': 'تسليم تلقائي',
  'shop.f2d': 'معظم الطلبات بتوصل لوحدها، ليل أو نهار.',
  'shop.f3t': 'أمان حسابك أولاً',
  'shop.f3d': 'بياناتك مش بتتخزن أبداً.',
  'shop.f4t': 'دعم حقيقي 24/7',
  'shop.f4d': 'ناس مش بوتات، معاك لحد ما طلبك يخلص.',
  'shop.cat.game-top-ups': 'شحن الألعاب',
  'shop.cat.gift-cards': 'بطاقات الهدايا',
  'shop.cat.game-keys': 'مفاتيح الألعاب',
  'footer.desc': 'شحن ألعاب وبطاقات هدايا ومفاتيح ألعاب بأسعار واضحة وتسليم سريع وفريق دعم حقيقي معاك لحد ما كل طلب يخلص.',
  'footer.shop': 'المتجر',
  'footer.help': 'المساعدة',
  'footer.track': 'تابع طلب',
  'footer.contact': 'تواصل مع الدعم',

  'err.wrongPersona.t': 'تم اختيار شخصية FUT غلط',
  'err.wrongPersona.d': 'شخصية FUT المختارة على حسابك غلط.',
  'err.wrongPersona.s': 'افتح FUT Web App على www.ea.com/fifa/ultimate-team/web-app\nاضغط على أيقونة الملف الشخصي وبدّل للشخصية الصحيحة\nسجّل خروج تماماً من كل الأجهزة والمتصفحات',
  'err.captcha.t': 'مطلوب التحقق من CAPTCHA',
  'err.captcha.d': 'EA بتطلب فحص أمان على حسابك.',
  'err.captcha.s': 'افتح FUT Web App على www.ea.com/fifa/ultimate-team/web-app\nسجّل دخول وأكمل التحقق من CAPTCHA لو ظهر\nسجّل خروج تماماً',
  'err.wrongUserPass.t': 'بيانات الدخول غير صحيحة',
  'err.wrongUserPass.d': 'الإيميل أو كلمة السر اللي أدخلتها غلط أو اتغيرت بعد الإرسال.',
  'err.wrongUserPass.s': 'تأكد إن إيميل وكلمة سر حساب EA لسه صح\nأعد ضبط كلمة السر من account.ea.com لو لزم\nبلّغ الموظف اللي جهّز طلبك عشان يحدّث بياناتك',
  'err.wrongBA.t': 'الكود الاحتياطي غلط',
  'err.wrongBA.d': 'الكود الاحتياطي غلط أو اتستخدم قبل كده.',
  'err.wrongBA.s': 'اذهب إلى account.ea.com ← الأمان ← التحقق عند الدخول ← الأكواد الاحتياطية\nولّد مجموعة جديدة من الأكواد\nأدخل واحد من الأكواد الجديدة في النموذج بالأسفل',
  'err.No2FA.t': 'التحقق عند الدخول (2FA) غير مفعّل',
  'err.No2FA.d': 'حساب EA بتاعك مفيهوش تحقق عند الدخول. ده مطلوب عشان النقل يشتغل.',
  'err.No2FA.s': 'اذهب إلى account.ea.com ← الأمان ← التحقق عند الدخول\nفعّل التحقق — اختر تطبيق المصادقة أو الإيميل\nبعد التفعيل اذهب إلى الأكواد الاحتياطية وولّد مجموعة جديدة\nأدخل واحد من الأكواد الجديدة في النموذج بالأسفل',
  'err.noTM.t': 'مفيش وصول لسوق الانتقالات في الويب آب',
  'err.noTM.d': 'حساب EA ده مش قادر يستخدم سوق الانتقالات في FUT Web App. ده مش سوق الانتقالات اللي جوا اللعبة — الاتنين منفصلين، فممكن يشتغل جوا اللعبة ويكون مقفول في الويب آب.',
  'err.noTM.s': 'افتح FUT Web App من www.ea.com/fifa/ultimate-team/web-app وادخل على Transfers ← Transfer Market\nلو مقفول أو مش متاح هناك، كمّل شرح FUT وكمّل لعب ماتشات لحد ما EA تفتحه لحسابك\nتأكد إن اشتراك EA Play / EA Pro فعّال لو مطلوب\nطلبك فضل مفتوح — أول ما سوق الانتقالات في الويب آب يشتغل، بلّغ الموظف اللي جهّز طلبك ونكمّل التحويل',
  'err.tlFull.t': 'قائمة الانتقالات ممتلئة',
  'err.tlFull.d': 'قائمة الانتقالات في FUT وصلت للحد الأقصى وبتمنع النقل.',
  'err.tlFull.s': 'افتح FUT Web App أو تطبيق EA على الموبايل\nاذهب إلى الانتقالات ← قائمة الانتقالات\nبِع أو احذف عناصر لتفضّي 5 خانات على الأقل\nسجّل خروج تماماً',
  'err.receiverTLFull.t': 'قائمة الانتقالات عندك ممتلئة',
  'err.receiverTLFull.d': 'قائمة الانتقالات عندك مفيهاش مكان — مش هينفع نبعت كوينز لحسابك لحد ما تفضّي خانات.',
  'err.receiverTLFull.s': 'افتح FUT Web App على www.ea.com/fifa/ultimate-team/web-app\nاذهب إلى الانتقالات ← قائمة الانتقالات\nبِع أو Quick Sell لعناصر لتفضّي 5 خانات على الأقل\nسجّل خروج تماماً من كل تطبيقات ومتصفحات EA',
  'err.FailedReceiverDeviceBan.t': 'حسابك اتعلّم من EA',
  'err.FailedReceiverDeviceBan.d': 'EA وضعت حظر على مستوى الجهاز على حسابك. ده محتاج تدخل.',
  'err.FailedReceiverDeviceBan.s': 'متدخلش على حساب EA بتاعك — بلّغ الموظف اللي جهّز طلبك فوراً',
  'err.FailWebAppNotYetUnlocked.t': 'FUT Web App لسه متفتحش',
  'err.FailWebAppNotYetUnlocked.d': 'حساب EA بتاعك لسه مفتحش FUT Web App، وده مطلوب للنقل.',
  'err.FailWebAppNotYetUnlocked.s': 'افتح FIFA/EA FC على الكونسول أو الكمبيوتر\nأكمل شرح FUT والعب كام ماتش على الأقل\nلما تقدر تدخل FUT Web App بلّغ الموظف اللي جهّز طلبك',
  'err.FailWebAppCustomerLocked.t': 'جلسة FUT Web App بتاعتك مقفولة',
  'err.FailWebAppCustomerLocked.d': 'جلسة الويب لحساب EA بتاعك مقفولة حالياً — غالباً لأنك داخل من جهاز تاني.',
  'err.FailWebAppCustomerLocked.s': 'سجّل خروج من FUT Web App على www.ea.com/fifa/ultimate-team/web-app\nسجّل خروج من تطبيق EA على الموبايل وكل الأجهزة التانية\nانتظر 5 دقايق ثم حاول مرة أخرى',
  'err.calcErrorMaintenance.t': 'صيانة مؤقتة من EA',
  'err.calcErrorMaintenance.d': 'EA في صيانة حالياً — بنعيد المحاولة تلقائياً. مش مطلوب منك حاجة.',
  'err.noPlayer.t': 'بنحدد نقل مناسب (إعادة محاولة)',
  'err.noPlayer.d': 'مفيش كارت لاعب مناسب حالياً — بنعيد المحاولة تلقائياً.',
  'err.safetyHold.t': 'مستنيين وقت آمن للتحويل',
  'err.safetyHold.d': 'السيستم بتاعنا بيكشف لما نظام EA المسؤول عن مراقبة تحويلات الكوينز يشتغل ويراقب حركة النقل في الماركت كله. دلوقتي النشاط عالي، فبنوقف التحويل مؤقتاً عشان نحميه. ده بيخص الماركت كله مش حسابك. أول ما نظام EA يهدى، طلبك هيكمل تلقائياً. مش مطلوب منك أي حاجة.',
  'err.belowMinTransfer.t': 'النقل أقل من الحد الأدنى',
  'err.belowMinTransfer.d': 'المبلغ المتبقي أقل من الحد الأدنى للنقل. تقدر تستأنف لإكمال نقل أصغر.',
  'err.belowMinTransfer.s': 'اضغط استئناف بالأسفل لإكمال التسليم بالمبلغ المتبقي',
  'err.notEnoughCoins.t': 'مفيش كوينز كفاية في الحساب',
  'err.notEnoughCoins.d': 'حسابك محتاج 10,000 كوينز على الأقل عشان النقل يشتغل.',
  'err.notEnoughCoins.s': 'اشتري أي لاعب رخيص من سوق الانتقالات عشان يبقى معاك كوينز في الحساب\nلما يبقى معاك 10,000 كوينز على الأقل اضغط إعادة المحاولة بالأسفل',
  'err.unassignedItemsPresent.t': 'فيه عناصر غير موزعة',
  'err.unassignedItemsPresent.d': 'فيه عناصر في حسابك لازم تتوزع قبل ما النقل يكمل.',
  'err.unassignedItemsPresent.s': 'افتح FUT Web App أو تطبيق EA\nاذهب إلى النادي ← العناصر غير الموزعة\nانقل كل العناصر لناديك أو لقائمة الانتقالات\nسجّل خروج تماماً',
  'err.console.t': 'لسه داخل Ultimate Team على الكونسول',
  'err.console.d': 'حسابك نشط في Ultimate Team على البلايستيشن أو الإكسبوكس.',
  'err.console.s': 'على الكونسول افتح FIFA/EA FC واذهب إلى Ultimate Team\nاضغط Options/Start ← Quit to Main Menu (متقفلش اللعبة بس)\nانتظر لحد ما اللعبة تطلع تماماً من Ultimate Team',
  'err.loginFailed.t': 'فشل الدخول — سجّل خروج من كل مكان',
  'err.loginFailed.d': 'EA رفضت الدخول، غالباً لأن حسابك نشط على جهاز أو متصفح تاني.',
  'err.loginFailed.s': 'سجّل خروج من تطبيق EA على كل الموبايلات والتابلت\nسجّل خروج من FUT Web App على www.ea.com/fifa/ultimate-team/web-app\nسجّل خروج من تطبيق FIFA/FC المرافق لو بتستخدمه',
  'err.LoginFailedDeviceBan.t': 'EA حظرت الدخول',
  'err.LoginFailedDeviceBan.d': 'EA حظرت الدخول من نظامنا. ده محتاج تدخل من فريقنا.',
  'err.LoginFailedDeviceBan.s': 'متدخلش على حساب EA بنفسك — بلّغ الموظف اللي جهّز طلبك فوراً',
  'err.FailedSessionExpiredCustomerLoggedIn.t': 'أنت داخل حالياً على تطبيق EA',
  'err.FailedSessionExpiredCustomerLoggedIn.d': 'حسابك نشط على تطبيق EA أو الويب على جهاز تاني.',
  'err.FailedSessionExpiredCustomerLoggedIn.s': 'سجّل خروج من FUT Web App على www.ea.com/fifa/ultimate-team/web-app\nسجّل خروج من تطبيق EA على الموبايل\nسجّل خروج من تطبيق FIFA/FC المرافق',
  'err.FailLoggedInConsoleTo.t': 'أنت داخل حالياً على تطبيق EA',
  'err.FailLoggedInConsoleTo.d': 'حسابك نشط على جهاز أو متصفح تاني.',
  'err.FailLoggedInConsoleTo.s': 'سجّل خروج من FUT Web App وتطبيق EA على كل الأجهزة',
  'err.FailedProxyConnectionError.t': 'مشكلة تقنية مؤقتة',
  'err.FailedProxyConnectionError.d': 'مشكلة تقنية بسيطة من ناحيتنا — بنعيد المحاولة تلقائياً. مش مطلوب منك حاجة.',
  'err.FailedProxyPoolExhausted.t': 'مشكلة شبكة مؤقتة',
  'err.FailedProxyPoolExhausted.d': 'مشكلة شبكة بسيطة من ناحيتنا — بنعيد المحاولة تلقائياً. مش مطلوب منك حاجة.',
  'err.FailedCouldNotStartTo.t': 'بدء النقل (إعادة محاولة)',
  'err.FailedCouldNotStartTo.d': 'فيه مشكلة لحظية في بدء النقل — بنعيد المحاولة تلقائياً.',
  'err.noClub.t': 'مفيش نادي FUT',
  'err.noClub.d': 'حساب EA بتاعك مفيهوش نادي FUT نشط — مش هينفع نستلم كوينز من غيره.',
  'err.noClub.s': 'افتح FIFA/EA FC وابدأ Ultimate Team\nأكمل إعداد FUT الأولي والعب ماتش واحد على الأقل\nلما يتجهز ناديك بلّغ الموظف اللي جهّز طلبك',
  'err.wrongConsole.t': 'المنصة غير متطابقة',
  'err.wrongConsole.d': 'المنصة في طلبك مش متطابقة مع حساب EA بتاعك.',
  'err.wrongConsole.s': 'بلّغ الموظف اللي جهّز طلبك — لازم يصحّح المنصة',
  'err.daily.t': 'تم الوصول لحد النقل اليومي',
  'err.senderTempban.t': 'المورّد متوقف مؤقتاً',
  'err.senderTempban.d': 'حساب المورّد عندنا عليه فترة انتظار قصيرة من EA. بيتم التعامل معاها تلقائياً — مش مطلوب منك حاجة.',
  'err.transfersInProgress.t': 'النقل شغال',
  'err.transfersInProgress.d': 'عمليات النقل شغالة حالياً — هيتحدّث قريباً.',

  'status.pending': 'قيد الانتظار',
  'status.ready': 'جاهز',
  'status.entered': 'تم الإدخال',
  'status.waitingForAssignment': 'في انتظار التعيين',
  'status.active': 'نشط',
  'status.finished': 'منتهي',
  'status.interrupted': 'متوقف',
  'status.tempbanCooldown': 'فترة انتظار',
  'status.cancelled': 'ملغي',
  'status.completed': 'مكتمل',

  'rbx.heroLine': 'جيم باس {gross} R$ · هيوصلك {net} R$',
  'rbx.hero.pass': 'أرسل الجيم باس',
  'rbx.hero.done': 'تم تسليم الروبوكس!',
  'rbx.hero.delivering': 'جاري تسليم الروبوكس',
  'rbx.hero.retrying': 'إعادة محاولة',
  'rbx.notFoundTitle': 'مش لاقيين الطلب ده',
  'rbx.createTitle': 'أنشئ جيم باس بسعر {gross} R$',
  'rbx.taxIntro': 'روبلوكس بتاخد {pct}% من كل بيع جيم باس، فالجيم باس بسعر <b>{gross} R$</b> بيدفع <b>{net} R$</b> — وده المبلغ اللي هيوصل حسابك، وهو اللي طلبك بيغطيه.',
  'rbx.steps': 'افتح روبلوكس ← <b>Create</b> ← اختر أي لعبة تملكها\nاذهب إلى <b>Associated Items ← Passes</b> وأنشئ باس\nافتح الباس ← <b>Configure ← Sales</b>\nفعّل <b>Item for Sale</b> واضبط السعر على <b>{gross} R$</b> بالظبط\nأرسله بالأسفل — رابط الباس أو رقمه فقط أو اسم مستخدم روبلوكس',
  'rbx.reqTitle': 'الجيم باس لازم كمان يحقق الشروط دي',
  'rbx.req': 'اقفل <b>Managed / Regional Pricing</b> (لازم يكون OFF)\nفي استبيان الـ Content Rating جاوب <b>No</b> على كل الأسئلة\nاللعبة تكون <b>Public</b> (لو مخفية: Archive ← Restore ← Make Public)\nحساب روبلوكس لازم يكون <b>موثّق السن (16+)</b>',
  'rbx.videoBtn': 'مش عارف تعمل جيم باس؟ شوف فيديو الشرح',
  'rbx.tabPass': 'رابط الباس أو رقمه',
  'rbx.tabUser': 'اسم مستخدم روبلوكس',
  'rbx.passLabel': 'رابط الجيم باس أو رقمه',
  'rbx.passPh': 'https://www.roblox.com/game-pass/000000000/…  أو 000000000 فقط',
  'rbx.reading': 'قراءة الجيم باس <b>#{id}</b> ✓',
  'rbx.badPaste': 'ده لسه مش شبه رابط جيم باس أو رقمه — الصق الرابط كامل أو الأرقام اللي فيه بس.',
  'rbx.userLabel': 'اسم مستخدم روبلوكس',
  'rbx.userPh': 'الحساب اللي هيستلم الروبوكس',
  'rbx.userHint': 'هنلاقي الباس على حسابك بنفسنا. لازم يكون سعره <b>{gross} R$</b> بالظبط، ومعروض للبيع، وفي إحدى ألعابك العامة.',
  'rbx.placeLabel': 'رقم اللعبة / المكان',
  'rbx.placePh': 'فقط لو عندك أكتر من لعبة',
  'rbx.sendPass': 'أرسل الجيم باس',
  'rbx.sendUser': 'أرسل اسم المستخدم',
  'rbx.sending': 'جاري الإرسال…',
  'rbx.allSet': 'كل حاجة تمام — مفيش مطلوب منك حاجة',
  'rbx.sentDone': 'تم إرسال <b>{net} R$</b> لحسابك على روبلوكس{user}.',
  'rbx.sentWait': 'استلمنا الجيم باس وطلبك مكتمل من ناحيتنا. <b>{net} R$</b> في الطريق لحسابك على روبلوكس.',
  'rbx.holdTitle': 'ليه بتاخد 5–7 أيام قبل ما تقدر تصرفها',
  'rbx.holdBody1': 'روبلوكس بتحتجز أرباح <em>كل</em> عملية بيع جيم باس لفترة انتظار قبل ما تتاح للاستخدام. الروبوكس هتظهر في حسابك كـ <b>معلّقة</b> الأول، وبعدين تبقى متاحة خلال <b>5–7 أيام</b>.',
  'rbx.holdBody2': 'ده نظام روبلوكس مع كل مشتريات الجيم باس — مش حاجة نقدر إحنا أو غيرنا نسرّعها. طلبك خلص.',
  'rbx.favourTitle': 'خدمة صغيرة',
  'rbx.favourBody': 'لو كل حاجة تمام، من فضلك علّم الطلب كـ <b>تم الاستلام</b> على Eldorado واترك تقييم. إحنا فريق صغير وده بيفرق معانا جداً. 🙏',
  'rbx.eldoradoBtn': 'أكّد وقيّم على Eldorado',
  'rbx.passOnFile': 'الجيم باس المسجّل:',
  'rbx.passLabelShort': 'الجيم باس:',
  'rbx.providerDown': 'الحالة المباشرة غير متاحة لحظياً — طلبك مش متأثر.',
  'rbx.tryAgain': 'حاول مرة أخرى',
  'rbx.retrying': 'جاري إعادة المحاولة…',
  'rbx.cancelledTitle': 'تم إلغاء هذا الطلب',
  'rbx.cancelledBody': 'تواصل مع الموظف اللي جهّز طلبك لو شايف إن ده حصل بالغلط.',
  'rbx.msg.noAccept': 'مقدرناش نقبل الرابط ده',
  'rbx.msg.net': 'مقدرناش نوصل للسيرفر. تأكد من اتصالك.',
  'rbx.msg.retryWait': 'مش ممكن إعادة المحاولة دلوقتي — حاول بعد دقيقة.',
  'rbx.msg.retryOk': 'جاري إعادة المحاولة — الصفحة بتتحدّث لوحدها.',

  'rbxi.gamepass_not_found.t': 'مش شايفين الجيم باس بتاعك لسه',
  'rbxi.gamepass_not_found.d': 'روبلوكس لسه منشرتش الباس، أو اتمسح أو اتغير اسمه بعد ما بعتّ الرابط. بنفضل نفحص لوحدنا، فالباس اللي لسه متعمل بيتلقط عادةً خلال دقايق.',
  'rbxi.gamepass_not_found.s': 'افتح صفحة الجيم باس وتأكد إنه لسه موجود\nتأكد إن السعر هو المبلغ الموضح بالأعلى بالظبط\nتأكد إن الباس On Sale\nبعدين اضغط حاول مرة أخرى بالأسفل',
  'rbxi.insufficient_customer_balance.t': 'طلبك في الانتظار',
  'rbxi.insufficient_customer_balance.d': 'بنعبّي الرصيد وطلبك هيتنفذ تلقائياً. مش مطلوب منك حاجة.',
  'rbxi.unknown_error.t': 'طلبك محتاج محاولة تانية',
  'rbxi.unknown_error.d': 'حاجة قطعت التسليم. بنعيد المحاولة تلقائياً — وتقدر تعيدها بنفسك كمان.',
  'rbxi.GAMEPASS_NOT_FOUND.t': 'ملقيناش الجيم باس ده',
  'rbxi.GAMEPASS_NOT_FOUND.d': 'روبلوكس مفيهاش باس على الرابط ده. الباسات الجديدة ممكن تاخد دقيقة عشان تظهر.',
  'rbxi.GAMEPASS_NOT_FOUND.s': 'افتح الرابط بنفسك وتأكد إن الباس بيفتح\nانسخ الرابط من شريط العنوان وإنت فاتح الباس\nانتظر دقيقة لو لسه عامله، وبعدين أرسل تاني',
  'rbxi.GAMEPASS_PRICE_MISMATCH.t': 'سعر الباس مش مطابق لطلبك',
  'rbxi.GAMEPASS_PRICE_MISMATCH.d': 'لازم يكون سعر الجيم باس هو المبلغ الموضح بالأعلى بالظبط — مش المبلغ اللي هيوصلك.',
  'rbxi.GAMEPASS_PRICE_MISMATCH.s': 'افتح الجيم باس ← Configure ← Sales\nاضبط السعر على المبلغ الموضح بالأعلى بالظبط\nاحفظ ثم أرسل الرابط تاني',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.t': 'التسعير الإقليمي شغال على الباس ده',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.d': 'روبلوكس بتعرض سعر مختلف في كل دولة، فالباس ده مينفعش يتشترى بمبلغ ثابت.',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.s': 'افتح الجيم باس ← Configure ← Sales\nاقفل Regional Pricing\nاحفظ ثم أرسل الرابط تاني',
  'rbxi.GAMEPASS_SELLER_MISMATCH.t': 'الباس ده تابع لحساب تاني',
  'rbxi.GAMEPASS_SELLER_MISMATCH.d': 'لازم يتعمل الجيم باس على نفس حساب روبلوكس اللي هيستلم الروبوكس.',
  'rbxi.GAMEPASS_SELLER_MISMATCH.s': 'اعمل الباس على الحساب اللي هيستلم الروبوكس\nأرسل الرابط الجديد',
  'rbxi.UNIVERSE_NOT_FOUND.t': 'مقدرناش نقرأ اللعبة اللي عليها الباس',
  'rbxi.UNIVERSE_NOT_FOUND.d': 'لازم يكون الباس تابع للعبة عامة (Public).',
  'rbxi.UNIVERSE_NOT_FOUND.s': 'افتح لعبتك ← Configure ← تأكد إنها Public\nبعدين أرسل الرابط تاني',
  'rbxi.ROBLOX_USER_NOT_FOUND.t': 'مش لاقيين حساب روبلوكس ده',
  'rbxi.ROBLOX_USER_NOT_FOUND.d': 'راجع كتابة اسم المستخدم، أو ابعت رابط الجيم باس بدلاً منه.',
  'rbxi.ROBLOX_USER_NOT_FOUND.s': 'ابعت رابط الجيم باس — بيحدد حسابك لوحده',
  'rbxi.OUT_OF_STOCK.t': 'طلبك في الطابور',
  'rbxi.OUT_OF_STOCK.d': 'بنعبّي مخزون الروبوكس وطلبك محجوز. هيكتمل تلقائياً أول ما المخزون يتوفر — مش مطلوب منك حاجة.',
  'rbxi.ROBLOX_DAILY_LIMIT.t': 'تم الوصول للحد اليومي من روبلوكس',
  'rbxi.ROBLOX_DAILY_LIMIT.d': 'روبلوكس بتحدد كمية الإرسال لحساب واحد في اليوم. طلبك هيكمل تلقائياً أول ما الحد يتجدد.',
  'rbxi.INSUFFICIENT_FUNDS.t': 'طلبك في الانتظار',
  'rbxi.INSUFFICIENT_FUNDS.d': 'طلبك محجوز وهيكتمل قريباً. مش مطلوب منك حاجة.',
  'rbxi.ORDER_ALREADY_EXISTS.t': 'الطلب ده شغال بالفعل',
  'rbxi.ORDER_ALREADY_EXISTS.d': 'الجيم باس بتاعك عندنا بالفعل — مش لازم تبعته تاني.',
};

export default ar;
